import PropTypes from 'prop-types'

import theme from 'theme'
import Text from 'components/common/Text'
import TrackedExternalLink from 'components/common/TrackedExternalLink'
import TextButton from 'components/common/TextButton'

export const GRADE_LETTER_SIZE = 210
export default function ScoreGrade({ score }) {
  return (
    <div
      css={{
        textAlign: 'center'
      }}
    >
      <div
        css={{
          width: GRADE_LETTER_SIZE,
          height: GRADE_LETTER_SIZE,
          backgroundColor: theme.colors.gray[0],
          borderRadius: theme.borderRadius[2],
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Text
          as="h1"
          css={{
            color: theme.colors.white[0],
            fontSize: theme.fontSizes[8]
          }}
        >
          {score || 'A'}
        </Text>
      </div>
      <TextButton
        as={TrackedExternalLink}
        css={{
          textDecoration: 'underline',
          fontSize: theme.fontSizes[0],
          color: theme.colors.steel[1],
          marginTop: theme.space[2]
        }}
        href="to_be_discussed"
      >
        How do I calculate my score?
      </TextButton>
    </div>
  )
}

ScoreGrade.propTypes = {
  score: PropTypes.string
}
